module.exports = __webpack_public_path__ + "img/ButtonIcon.8379a621.svg";